import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import ImageArrow from "./arrow.svg?url";

export const StyledDiv = styled.div`
  position: relative;

  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 16px;

  cursor: pointer;

  ${props => props.theme.breakpoints.up("tablet")} {
    min-block-size: 32px;

    line-height: 16px;
  }

  time {
    user-select: none;
  }
`;

export const PublishedDateContainer = styled.div``;

type UpdatedDateProps = {
  $isToggle: boolean;
};
export const UpdatedDateContainer = styled.div<UpdatedDateProps>`
  position: relative;
  &:after {
    position: absolute;
    content: "";

    inline-size: 10px;
    block-size: 6px;
    margin-block-start: 5px;
    margin-inline-start: 8px;

    background-image: url(${ImageArrow});
    background-repeat: no-repeat;

    transform: rotate(0deg);

    ${props => {
      if (!props.$isToggle) return;
      return css`
        transform: rotate(180deg);
      `;
    }}
  }
`;
